module.exports = "/fonts/quark-light.ttf?e8c7ba2ef8b81bd642fe7939e48a90d9";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/fonts/Quark/quark-light.ttf
// module id = HvQ8
// module chunks = 0